export function registerServiceWorker() {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') return;
  if (!('serviceWorker' in navigator)) return;

  const basePath = process.env.BASE_URL || '/';
  const normalizedBase = basePath.endsWith('/') ? basePath : `${basePath}/`;
  const swUrl = `${normalizedBase}service-worker.js`;

  const UPDATE_FLAG_KEY = 'swReloading';
  const markReloading = () => sessionStorage.setItem(UPDATE_FLAG_KEY, '1');
  const isReloading = () => sessionStorage.getItem(UPDATE_FLAG_KEY) === '1';
  if (isReloading()) {
    sessionStorage.removeItem(UPDATE_FLAG_KEY);
  }

  const hardReload = () => {
    if (isReloading()) return;
    markReloading();
    window.location.reload();
  };

  const applyUpdate = (registration) => {
    if (!registration || !registration.waiting) {
      return;
    }
    navigator.serviceWorker.addEventListener('controllerchange', hardReload, { once: true });
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  };

  const attachUpdateListeners = (registration) => {
    if (!registration) return;
    registration.onupdatefound = () => {
      const installing = registration.installing;
      if (!installing) return;
      installing.onstatechange = () => {
        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
          applyUpdate(registration);
        }
      };
    };
  };

  const registerNow = async () => {
    const registration = await navigator.serviceWorker.register(swUrl, { updateViaCache: 'none' });
    attachUpdateListeners(registration);
    applyUpdate(registration);
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    registerNow();
  } else {
    window.addEventListener('load', registerNow, { once: true });
  }
}
